export default __webpack_public_path__ + "static/media/piano.19eebe93.png";